import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "box" }

import TrackerForm from '../components/TrackerForm.vue'
import TrackerList from '../components/TrackerList.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TrackerForm)
    ]),
    _createElementVNode("div", null, [
      _createVNode(TrackerList)
    ])
  ]))
}
}

})